// extracted by mini-css-extract-plugin
module.exports = {"tableTitle":"table_tableTitle__3DvTN","tableContainer":"table_tableContainer__uaU2A"};